/*
  Опрос хода проверки по реестру банкротств - общий для проверки счёта и для
  запроса сообщений по карточке (23.10.2026).
*/

export const POLL_MS = 2000
export const POLL_LIMIT = 150

/* Переживает ли опрос эту ошибку. Сбой связи (0), частота обращений (429) и отказ
   службы, который сервер пометил «повтор поможет» (503 с `details.retry`), - да:
   ход проверки служба хранит, и следующий опрос его догонит. Остальное (409 -
   состав изменился, 404, 403, и 503 с `retry: false` - ключ не принят, адрес не
   пускают, форма ответа незнакомая) повтором не лечится: опрос встаёт сразу и
   кнопка свободна. До 23.10.2026 любой 503 считался временным, и кабинет пять
   минут опрашивал службу, которая не пускает этот сервер (ревизия). */
export function isTemporary(error) {
  const status = error?.status
  if (status === 0 || status === 429) return true
  return status === 503 && error?.details?.retry !== false
}
